
(function () {
  var EXTRA_GIFTS = [
    {
      barId: 'b6141e93-67e4-4815-a98c-7e6f4a9f3f53', // 2 BELTS
      image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/belt_in_zakje.png?v=1789251488',
      textKey: 'kaching_free_shipping',
      fallbackText: '+ GRATIS Verzending',
      fullPrice: ''
    },
    {
      barId: '48884e0e-e11e-445d-b6a2-13135a3b7171', // 2 VESTEN
      image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/Mystery_gift.png?v=1790081872',
      textKey: 'kaching_mystery_gift',
      fallbackText: '+ GRATIS Mystery Gift',
      fullPrice: ''
    }
  ];

  var ATTR = 'data-zone2-extra-gift';

  function translate(key, fallback) {
    var value = window.z2Translations && window.z2Translations[key];

    if (!value || String(value).indexOf('translation missing') === 0) {
      return fallback;
    }

    return value;
  }

  function buildGift(source, cfg) {
    var gift = source.cloneNode(true);

    gift.setAttribute(ATTR, '');
    gift.removeAttribute('data-free-gift-id');

    var img = gift.querySelector('.kaching-bundles__free-gift__image');
    var sourceImg = source.querySelector('.kaching-bundles__free-gift__image');

    if (img && img.tagName === 'IMG') {
      // Minimaal 60 px als basis, of de echte breedte als die groter is.
      // Kaching blijft de zichtbare afmetingen en styling bepalen.
      var imageWidth = Math.max(
        60,
        Math.ceil(sourceImg.getBoundingClientRect().width)
      );

      function imageUrl(scale) {
        var url = new URL(cfg.image, document.baseURI);

        url.searchParams.set('width', imageWidth * scale);
        url.searchParams.set('quality', '90');

        return url.href;
      }

      // Verwijder eventueel meegekopieerde afbeeldingsverwijzingen.
      [
        'srcset',
        'sizes',
        'data-src',
        'data-srcset',
        'data-sizes',
        'data-original'
      ].forEach(function (attr) {
        img.removeAttribute(attr);
      });

      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');

      img.alt = translate(
        cfg.textKey,
        cfg.fallbackText
      ).replace(/^\+\s*/, '');

      // 60 / 120 / 180 px, of groter als de weergave dat nodig heeft.
      img.srcset =
        imageUrl(1) + ' 1x, ' +
        imageUrl(2) + ' 2x, ' +
        imageUrl(3) + ' 3x';

      img.src = imageUrl(3);
    }

    var text = gift.querySelector(
      '.kaching-bundles__free-gift__text'
    );

    if (text) {
      text.textContent = translate(
        cfg.textKey,
        cfg.fallbackText
      );
    }

    var price = gift.querySelector(
      '.kaching-bundles__free-gift__full-price'
    );

    if (price) {
      if (cfg.fullPrice) {
        price.textContent = cfg.fullPrice;
      } else {
        price.remove();
      }
    }

    return gift;
  }

  function ensure(bar, cfg) {
    var native = bar.querySelectorAll(
      '.kaching-bundles__free-gift:not([' + ATTR + '])'
    );

    var ours = bar.querySelectorAll('[' + ATTR + ']');

    if (!native.length) {
      ours.forEach(function (n) {
        n.remove();
      });
      return;
    }

    var last = native[native.length - 1];

    var divider = bar.querySelector(
      '.kaching-bundles__free-gift__divider[' + ATTR + ']'
    );

    var gift = bar.querySelector(
      '.kaching-bundles__free-gift[' + ATTR + ']'
    );

    if (!divider || !gift) {
      ours.forEach(function (n) {
        n.remove();
      });

      var nativeDivider = bar.querySelector(
        '.kaching-bundles__free-gift__divider:not([' + ATTR + '])'
      );

      divider = nativeDivider
        ? nativeDivider.cloneNode(true)
        : document.createElement('div');

      divider.className = 'kaching-bundles__free-gift__divider';
      divider.setAttribute(ATTR, '');

      gift = buildGift(last, cfg);
    }

    // Altijd direct na de laatste echte gift houden,
    // ook wanneer Kaching opnieuw rendert.
    if (
      last.nextElementSibling !== divider ||
      divider.nextElementSibling !== gift
    ) {
      last.after(divider, gift);
    }
  }

  var queued = false;

  function run() {
    queued = false;

    EXTRA_GIFTS.forEach(function (cfg) {
      document.querySelectorAll(
        '[data-deal-bar-id="' + cfg.barId + '"]'
      ).forEach(function (bar) {
        ensure(bar, cfg);
      });
    });
  }

  function schedule() {
    if (!queued) {
      queued = true;
      setTimeout(run, 0);
    }
  }

  new MutationObserver(schedule).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  schedule();
})();
